webpackJsonp([32],{

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('sidebar'),_vm._v(" "),_c('main',{staticClass:"col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10 h-100 pb-5",attrs:{"role":"main"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-5"},[_c('app-header'),_vm._v(" "),_c('page-header',{attrs:{"page-title":_vm.pageData.title,"breadcrumb":_vm.pageData.breadcrumb}})],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"club-section px-0 mx-0 px-lg-5 mx-lg-5  mt-0 mt-md-5 pb-5 "},[_c('div',{staticClass:"container-fluid "},[_c('div',{staticClass:"row justify-content-start mb-5 mt-md-5 mt-lg-0 pt-5 pt-sm-0"},[_c('div',{staticClass:"col-12 px-0 px-sm-3"},[_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"badge badge-primary d-flex align-items-center"},[_c('img',{staticClass:"img-fluid mr-3 star-ic",attrs:{"src":"/static/images/icons/evaluations/star.png","alt":""}}),_vm._v("\n                                    Star: 2\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-4 pt-1  px-0 px-sm-3"},[_c('div',{staticClass:"club-bg club-table "},[_c('table',{staticClass:"table-blue-wide table-blue-wide-p w-100"},[_c('thead',[_c('tr',[_c('th',[_vm._v("კლუბის სახელი")]),_vm._v(" "),_c('th',[_vm._v("ლოგო")]),_vm._v(" "),_c('th',[_vm._v("საკონტაქტო პირი")]),_vm._v(" "),_c('th',[_vm._v("მობილური")]),_vm._v(" "),_c('th',[_vm._v("ელ.ფოსტა")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{attrs:{"data-label":"კლუბის სახელი"}},[_vm._v("Oriental club")]),_vm._v(" "),_c('td',{attrs:{"data-label":"ლოგო"}},[_c('img',{staticClass:"img-fluid mr-3",staticStyle:{"height":"25px"},attrs:{"src":"/static/images/icons/evaluations/recover.png","alt":""}})]),_vm._v(" "),_c('td',{attrs:{"data-label":"საკონტაქტო პირი"}},[_vm._v("იური ნიკოლეიშვილი")]),_vm._v(" "),_c('td',{attrs:{"data-label":"მობილური"}},[_vm._v("551070391")]),_vm._v(" "),_c('td',{attrs:{"data-label":"ელ.ფოსტა"}},[_vm._v("orientalclub.ug@gmail.com")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-4 pt-1  px-0 px-sm-3"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"d-inline-block bg-white-88 border-round py-md-0 py-lg-2 px-3 px-sm-4"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between py-3 py-sm-2 px-0 px-sm-3 mx-1"},[_c('div',{staticClass:"d-flex align-items-center mr-4 pr-2"},[_c('img',{staticClass:"img-fluid mr-2 mr-sm-3 p-0 p-sm-1 ic",attrs:{"src":"/static/images/icons/evaluations/recover.png","alt":"accepted evaluation"}}),_vm._v(" "),_c('span',{staticClass:"s-b-1"},[_vm._v("პროცესშია")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center mr-4 pr-2"},[_c('img',{staticClass:"img-fluid mr-2 mr-sm-3 p-0 p-sm-1 ic",attrs:{"src":"/static/images/icons/evaluations/fail.png","alt":"failed evaluation"}}),_vm._v(" "),_c('span',{staticClass:"s-b-1"},[_vm._v("უარყოფილია")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"img-fluid mr-2 mr-sm-3 p-0 p-sm-1 ic",attrs:{"src":"/static/images/icons/evaluations/accept.png","alt":"recover evaluation"}}),_vm._v(" "),_c('span',{staticClass:"s-b-1"},[_vm._v("დამტკიცებულია")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 text-md-center offset-md-2 mt-4  col-lg-6 offset-lg-0 text-lg-left"},[_c('span',{staticClass:"link-red f-heading-bold"},[_vm._v("\n                                        პროექტის დამატება შესაძლებელია თვის\n                                        ნებისმიერ რიცხვში გარდა\n                                        1-დან 5-მდე და 15-დან 20-მდე\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-md-2 mt-lg-5 pt-4  px-0 px-sm-3"},[_c('div',{staticClass:"club-bg"},[_c('table',{staticClass:"table-blue-wide table-blue-wide-p"},[_c('thead',[_c('tr',[_c('th',[_vm._v("პროექტი")]),_vm._v(" "),_c('th',[_vm._v("პროექტის ღირებულება")]),_vm._v(" "),_c('th',[_vm._v("დამტკიცებული ღირებულება")]),_vm._v(" "),_c('th',[_vm._v("ფინანსები")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("აღწერა")]),_vm._v(" "),_c('th',[_vm._v("კომენტარი")]),_vm._v(" "),_c('th',[_vm._v("წაშლა")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("სტატუსი")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{attrs:{"data-label":"პროექტი"}},[_vm._v("შეხვედრა დათო ტურაშვლითან")]),_vm._v(" "),_c('td',{attrs:{"data-label":"პროექტის ღირებულება"}},[_vm._v("5 ლარი")]),_vm._v(" "),_c('td',{attrs:{"data-label":"დამტკიცებული ღირებულება"}},[_vm._v("5 ლარი")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-label":"ფინანსები"}},[_c('img',{staticClass:"img-fluid ic-w",attrs:{"src":"/static/images/icons/fee-pay-grey.png"}})]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-label":"აღწერა","onclick":"callModalClubInfo()"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/information-grey.png"}})]),_vm._v(" "),_c('td',{attrs:{"data-label":"კომენტარი"}},[_vm._v("ბიუჯეტის ველში.")]),_vm._v(" "),_c('td',{attrs:{"data-label":"წაშლა"}},[_vm._v("წაშლა შეუძლებელია")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-label":"სტატუსი"}},[_c('img',{staticClass:"img-fluid mr-2 mr-sm-3 p-0 p-sm-1 ic",attrs:{"src":"/static/images/icons/evaluations/accept.png"}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"data-label":"პროექტი"}},[_vm._v("შეხვედრა დათო ტურაშვლითან")]),_vm._v(" "),_c('td',{attrs:{"data-label":"პროექტის ღირებულება"}},[_vm._v("5 ლარი")]),_vm._v(" "),_c('td',{attrs:{"data-label":"დამტკიცებული ღირებულება"}},[_vm._v("5 ლარი")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-label":"ფინანსები"}},[_c('img',{staticClass:"img-fluid ic-w",attrs:{"src":"/static/images/icons/fee-pay-grey.png"}})]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-label":"აღწერა"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/information-grey.png"}})]),_vm._v(" "),_c('td',{attrs:{"data-label":"კომენტარი"}},[_vm._v("გთხოვთ, შეცვალოთ აუდიტორია, რადგან კლუბების სივრცე როგორც იცით #116-ია. გთხოვთ ყველა საჭირო რესურსის ჩამონათვალი თანმიმდევრულად ცალ-ცალკე გაწეროთ რაოდენობებისა და ფასების მითითებით. გაითვალისწინეთ, რომ უნივერსიტეტისგან მოთხოვნილი არსებული რესურსი მაგალითად: ბრენდირებული ღვინო, პუფი, მიკროფონი დ აპარატურა უფასოა ამიტომ მას ნუ მოაქცევთ გაწერილი ბიუჯეტის ველში.")]),_vm._v(" "),_c('td',{attrs:{"data-label":"წაშლა"}},[_vm._v("წაშლა შეუძლებელია")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-label":"სტატუსი"}},[_c('img',{staticClass:"img-fluid mr-2 mr-sm-3 p-0 p-sm-1 ic",attrs:{"src":"/static/images/icons/evaluations/accept.png"}})])])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade ",attrs:{"tabindex":"-1","aria-hidden":"true","role":"dialog","id":"club_info"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md"},[_c('div',{staticClass:"modal-content modal-blue"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-12 d-flex"},[_c('h3',[_vm._v("UG ლიტერატურული კლუბი")]),_vm._v(" "),_c('button',{staticClass:"btn ml-auto btn-light-bold"},[_vm._v("ბეჭდვა")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3"},[_c('hr'),_vm._v(" "),_c('h4',[_vm._v("პროექტის სათაური")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-3 col-form-label sr-only",attrs:{"for":"damoukidebeli"}},[_vm._v("project name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 offset-sm-2"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"damoukidebeli","name":"damoukidebeli","value":"შეხვედრა დათო ტურაშვლითან"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('label',{staticClass:"col-4 col-form-label text-left",attrs:{"for":"m_tanxa"}},[_vm._v("სტუდენტური ფონდიდან მოთხოვნილი თანხა")]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"m_tanxa","value":"5","name":"m_tanxa"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('label',{staticClass:"col-4 col-form-label text-left",attrs:{"for":"studcount"}},[_vm._v("სავარაუდო მონაწილეთა რაოდენობა:")]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"studcount","value":"5","name":"studcount"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('label',{staticClass:"col-4 col-form-label text-left",attrs:{"for":"startdate"}},[_vm._v("პროექტის დაწყების თარიღი:")]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('input',{staticClass:"form-control",attrs:{"type":"date","id":"startdate","name":"startdate"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('label',{staticClass:"col-4 col-form-label text-left",attrs:{"for":"enddate"}},[_vm._v("პროექტის დასრულების თარიღი:")]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('input',{staticClass:"form-control",attrs:{"type":"date","id":"enddate","name":"enddate"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('label',{staticClass:"col-4 col-form-label text-left",attrs:{"for":"adgili"}},[_vm._v("ადგილი")]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"adgili","name":"adgili"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('label',{staticClass:"col-4 col-form-label text-left",attrs:{"for":"drostart"}},[_vm._v("პროექტის დაწყების დრო")]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"drostart","name":"drostart"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row align-items-center"},[_c('label',{staticClass:"col-4 col-form-label text-left",attrs:{"for":"droend"}},[_vm._v("პროექტის დასრულების დრო")]),_vm._v(" "),_c('div',{staticClass:"col-6 "},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"droend","name":"droend"}})])]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('span',[_vm._v("\n                                            მე, ზემოხსენებული პროექტის ხელმძღვანელი \n                                            "),_c('strong',[_vm._v("ერეკლე გოგიშვილი                 ")]),_vm._v("ვიღებ \n                                            პასუხისმგებლობას, რომ სტუდენტური ფონდიდან მიღებულ \n                                            ყოველგვარ ფინანსურ ან მატერიალურ დახმარებას გამოვიყენებ \n                                            ისე, როგორც გათვალისწინებულია პროექტით. მე თანახმა ვარ\n                                            დავიცვა ფონდის მიერ დადგენილი ანგარიშგების წესები. პროექტის \n                                            განხორციელებაში დაშვებული დარღვევების შემთხვევაში, თანახმა \n                                            ვარ გრანტის სახით მიღებული თანხა და ამ თანხით შეძენილი ქონება \n                                            დავუბრუნო ფონდს, მისი გადაწყვეტილების შესაბამისად.  \n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-3"},[_c('hr'),_vm._v(" "),_c('h4',[_vm._v("პროექტის აღწერა")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row pt-4"},[_c('div',{staticClass:"col-12 "},[_c('h4',{staticClass:"text-left mb-4"},[_vm._v("პრობლემის განსაზღვრა,\n                                                მიზნები: (რამ გამოიწვია ამ პროექტის განხორციელების იდეა, \n                                                აქტუალობა, მიზნები, რას ემსახურება თქვებნი პროექტი)")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":"agwera","rows":"8","id":"agwera"}},[_vm._v("                                                საქართველოს უნივერსიტეტის ლიტერატურული კლუბის მიზანია ლიტერატურისა და წიგნის პოპულარიზაცია, სტუდენტების ინიციატივების პროექტის სახით განხორციელება. ინტელექტუალური, კრეატიული და შემეცნებითი ხასიათის ღონისძიებების ორგანიზება. ამასთან, სტუდენტების ჩართულობა არაფორმალურ განათლებაში და საუნივერსიტეტო ცხოვრების გამრავალფეროვნება.\n                                            ")])]),_vm._v(" "),_c('label',{staticClass:"col-sm-3 col-form-label sr-only",attrs:{"for":"agwera"}},[_vm._v("agwera")])]),_vm._v(" "),_c('div',{staticClass:"form-group row pt-4"},[_c('div',{staticClass:"col-12 "},[_c('h4',{staticClass:"text-left mb-4"},[_vm._v("\n                                                პროექტის მოკლე რეზიუმე: (რამოდენიმე წინადადებით პროექტის შესახებ, რა, სად, როგორ , ვინ, როდის)")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":"rezume","rows":"8","id":"agwera"}},[_vm._v("                                                საქართველოს უნივერსიტეტის ლიტერატურული კლუბის მიზანია ლიტერატურისა და წიგნის პოპულარიზაცია, სტუდენტების ინიციატივების პროექტის სახით განხორციელება. ინტელექტუალური, კრეატიული და შემეცნებითი ხასიათის ღონისძიებების ორგანიზება. ამასთან, სტუდენტების ჩართულობა არაფორმალურ განათლებაში და საუნივერსიტეტო ცხოვრების გამრავალფეროვნება.\n                                            ")])]),_vm._v(" "),_c('label',{staticClass:"col-sm-3 col-form-label sr-only",attrs:{"for":"rezume"}},[_vm._v("rezume")])]),_vm._v(" "),_c('div',{staticClass:"form-group row pt-4"},[_c('div',{staticClass:"col-12 "},[_c('h4',{staticClass:"text-left mb-4"},[_vm._v("\n                                                სამოქმედო გეგმა: (საკითხების ჩამონათვალი რომელიც უნდა გააკეთოთ, რა საკითხს როდის და როგორ აკეთებთ)\n                                            ")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":"gegma","rows":"8","id":"gegma"}},[_vm._v("                                                საქართველოს უნივერსიტეტის ლიტერატურული კლუბის მიზანია ლიტერატურისა და წიგნის პოპულარიზაცია, სტუდენტების ინიციატივების პროექტის სახით განხორციელება. ინტელექტუალური, კრეატიული და შემეცნებითი ხასიათის ღონისძიებების ორგანიზება. ამასთან, სტუდენტების ჩართულობა არაფორმალურ განათლებაში და საუნივერსიტეტო ცხოვრების გამრავალფეროვნება.\n                                            ")])]),_vm._v(" "),_c('label',{staticClass:"col-sm-3 col-form-label sr-only",attrs:{"for":"gegma"}},[_vm._v("gegma")])]),_vm._v(" "),_c('div',{staticClass:"form-group row pt-4"},[_c('div',{staticClass:"col-12 "},[_c('h4',{staticClass:"text-left mb-4"},[_vm._v("\n                                                მოსალოდნელი შედეგები: (პროექტის განხორციელების შემდეგ რა შედეგებს მიიღებთ, რა შეიცვლება უკეთესობისკენ)\n                                            ")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":"shedegebi","rows":"8","id":"shedegebi"}},[_vm._v("                                                საქართველოს უნივერსიტეტის ლიტერატურული კლუბის მიზანია ლიტერატურისა და წიგნის პოპულარიზაცია, სტუდენტების ინიციატივების პროექტის სახით განხორციელება. ინტელექტუალური, კრეატიული და შემეცნებითი ხასიათის ღონისძიებების ორგანიზება. ამასთან, სტუდენტების ჩართულობა არაფორმალურ განათლებაში და საუნივერსიტეტო ცხოვრების გამრავალფეროვნება.\n                                            ")])]),_vm._v(" "),_c('label',{staticClass:"col-sm-3 col-form-label sr-only",attrs:{"for":"shedegebi"}},[_vm._v("shedegebi")])]),_vm._v(" "),_c('div',{staticClass:"form-group row pt-4"},[_c('div',{staticClass:"col-12 "},[_c('h4',{staticClass:"text-left mb-4"},[_vm._v("\n                                                საინიციატივო ჯგუფი: (სია იმ სტუდენტების/ადამიანების ვინც არის ჩართული პროექტის განხორციელებაში და მოკლედ მათი გამოცდილება)                                ")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":"sainiciativo","rows":"8","id":"sainiciativo"}},[_vm._v("                                                საქართველოს უნივერსიტეტის ლიტერატურული კლუბის მიზანია ლიტერატურისა და წიგნის პოპულარიზაცია, სტუდენტების ინიციატივების პროექტის სახით განხორციელება. ინტელექტუალური, კრეატიული და შემეცნებითი ხასიათის ღონისძიებების ორგანიზება. ამასთან, სტუდენტების ჩართულობა არაფორმალურ განათლებაში და საუნივერსიტეტო ცხოვრების გამრავალფეროვნება.\n                                            ")])]),_vm._v(" "),_c('label',{staticClass:"col-sm-3 col-form-label sr-only",attrs:{"for":"sainiciativo"}},[_vm._v("sainiciativo")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-0 pt-3 mt-sm-5 pt-sm-5 mb-3"},[_c('button',{staticClass:"btn btn-light-bold",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("ok")])])])])])])])}]


/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manage_vue__ = __webpack_require__(852);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f21df8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_vue__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f21df8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f21df8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(687)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-565437c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_565437c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__ = __webpack_require__(678);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  components: {
    skSidebar: __WEBPACK_IMPORTED_MODULE_2__components_skeletons_sk_sidebar__["a" /* default */],
    skNavbarSidebar: __WEBPACK_IMPORTED_MODULE_3__components_skeletons_sk_navbar_sidebar__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['sidebarNavItems'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture', 'user'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('conversation', ['unreadConversations'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['token']))
});

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-sidebar'
});

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-sidebar'
});

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breadcrumb',
  props: ['items']
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(77);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_3__language_switcher__["a" /* default */],
    SkNavbarHeader: __WEBPACK_IMPORTED_MODULE_4__skeletons_sk_navbar_header__["a" /* default */],
    NavHeaderLg: __WEBPACK_IMPORTED_MODULE_5__navbar_nav_header_lg__["a" /* default */],
    NavHeaderMd: __WEBPACK_IMPORTED_MODULE_6__navbar_nav_header_md__["a" /* default */],
    NavHeaderSm: __WEBPACK_IMPORTED_MODULE_7__navbar_nav_header_sm__["a" /* default */]
  },
  computed: _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('navbar', ['headerMenuTree'])), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('auth', ['studentPicture'])),
  methods: {
    setLocale: function setLocale(locale) {
      __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */].locale = locale;
      localStorage.setItem('locale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification_item__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__ = __webpack_require__(78);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_3__skeletons_sk_list__["a" /* default */],
    NotificationItem: __WEBPACK_IMPORTED_MODULE_1__notification_item__["a" /* default */]
  },
  data: function data() {
    return {
      page: 1,
      per_page: 20
    };
  },
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    notifications: 'notifications/notifications',
    loading: 'notifications/loading',
    newNotifications: 'notifications/newNotifications'
  })),
  methods: {
    setSeen: function setSeen(notification) {
      if (!notification.seen_at) {
        this.$store.dispatch('notifications/seen', notification.notificationID).then(function () {
          if (notification.link) window.location.href = notification.link;
        });
      } else if (notification.link) window.location.href = notification.link;
    },
    seeAll: function seeAll() {
      var _this = this;

      this.$store.dispatch('notifications/seeAll').then(function () {
        _this.$store.dispatch('notifications/loadNotifications');

        _this.$store.dispatch('notifications/loadCounts');
      });
    },
    loadNotifications: function loadNotifications() {
      this.$store.dispatch('notifications/loadNotifications', {
        page: this.page,
        per_page: this.per_page
      });
    }
  }
});

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notification-item',
  props: ['item'],
  computed: {
    link: function link() {
      return this.item.link || null;
    }
  },
  methods: {
    handleClick: function handleClick($event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.$emit('seen', this.item);
    }
  }
});

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sk-navbar-header'
});

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(660);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-lg',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* default */],
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_switcher__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-md',
  components: {
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_1__language_switcher__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  }))
});

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-header-sm',
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */]
  },
  props: ['headerMenuTree', 'studentPicture'],
  computed: _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    token: 'auth/token'
  })),
  methods: {
    setLocale: function setLocale(locale) {
      this.$store.dispatch('language/setLocale', locale);
      this.$emit('changed-locale', locale);
    }
  }
});

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  name: 'page-title'
});

/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__ = __webpack_require__(676);
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  components: {
    NavHeader: __WEBPACK_IMPORTED_MODULE_0__navbar_nav_header__["a" /* default */]
  }
});

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_title__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breadcrumb__ = __webpack_require__(675);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-header',
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__breadcrumb__["a" /* default */],
    PageTitle: __WEBPACK_IMPORTED_MODULE_0__page_title__["a" /* default */]
  },
  props: ['pageTitle', 'breadcrumb']
});

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(684)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a8eb91f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8eb91f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_491419d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d0113b8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(663);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25221a9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35972473_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_title_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a57a6812_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('tb-skeleton',{attrs:{"aspect-ratio":1,"shape":"circle"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.1}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)])])])])}
var staticRenderFns = []


/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"5px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"padding-left":"10px","margin-top":"10px"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.15}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aside',{staticClass:"col-12 col-sm-3 col-md-2 col-lg-2 position-fixed sd-bg px-sm-0 px-md-0 px-lg-1 px-xl-3 d-none d-sm-block"},[_c('div',{staticClass:"sidebar flex-nowrap overflow-auto px-0 d-flex align-items-center flex-column h-100 px-md-0 px-lg-1 px-xl-4"},[_c('div',{staticClass:"mb-auto mt-5 "},[(!_vm.user || !_vm.studentPicture)?_c('sk-sidebar'):_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"circle-border "},[_c('div',{staticClass:"circle"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":"profile-image"}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center mt-4 mb-md-5 mb-lg-0"},[_c('p',{staticClass:"f-p1 mb-2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'fullName')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'speciality')))]),_vm._v(" "),_c('p',{staticClass:"f-p2"},[_vm._v(_vm._s(_vm.helpers.getLocalizedField(_vm.user, 'studentStatus')))])]),_vm._v(" "),(!_vm.sidebarNavItems || _vm.sidebarNavItems.length === 0)?_c('sk-navbar-sidebar'):_c('ul',{staticClass:"nav flex-column"},_vm._l((_vm.sidebarNavItems),function(navItem){return _c('li',{staticClass:"nav-item"},[(navItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"to":navItem.link}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()]):_c('a',{staticClass:"nav-link d-flex align-items-baseline justify-content-start",attrs:{"id":navItem.htmlID ? navItem.htmlID : '',"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navItem.link + '&token=' + _vm.token}},[_c('img',{staticClass:"img-fluid",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),(_vm.unreadConversations > 0 && navItem.htmlID === 'conversations')?_c('span',{staticClass:"ml-1 badge-danger badge-pill"},[_vm._v(_vm._s(_vm.unreadConversations))]):_vm._e()])],1)}),0)],1),_vm._v(" "),_c('div',{staticClass:" d-flex justify-content-center ug-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])],1)])])])}
var staticRenderFns = []


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(685);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("635519c8", content, true, {});

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"breadcrumb.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-container  mb-3"},[_c('nav',{attrs:{"aria-label":"breadcrumb d-none d-sm-none d-md-block"}},[_c('ol',{staticClass:"breadcrumb  ml-auto "},_vm._l((_vm.items),function(item){return _c('li',{class:['breadcrumb-item', { active: item.isActive } ]},[_c('router-link',{attrs:{"to":item.link}},[_vm._v("\n          "+_vm._s(item.title)+"\n        ")])],1)}),0)])])}
var staticRenderFns = []


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("3cd26278", content, true, {});

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".no-notifications[data-v-565437c6]{font-weight:700;text-align:center;font-size:14px;min-height:56px}.dropdown-menu[data-v-565437c6]{padding:1.4rem 0 0;min-width:26.5rem}.dropdown-menu-items[data-v-565437c6]{max-height:300px;overflow-y:auto}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar{width:5px;height:5px}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb{background:#c2c2c2;border-radius:5px;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover{background:#c2c2c2;-webkit-box-shadow:unset}.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track{padding-left:1rem;background:#f2f2f2;-webkit-box-shadow:inset 0 0 6px transparent;border-radius:0}", "", {"version":3,"sources":["F:/myugfront/src/components/notifications.vue"],"names":[],"mappings":"AACA,mCACE,gBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,eAAiB,CAClB,AACD,gCACE,mBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,yDACE,UAAW,AACX,UAAY,CACb,AACD,+DACE,mBAAoB,AACpB,kBAAmB,AACnB,wBAA0B,CAC3B,AACD,qEACE,mBAAoB,AACpB,wBAA0B,CAC3B,AACD,+DACE,kBAAmB,AACnB,mBAAoB,AACpB,6CAA8C,AAC9C,eAAiB,CAClB","file":"notifications.vue","sourcesContent":["\n.no-notifications[data-v-565437c6] {\n  font-weight: bold;\n  text-align: center;\n  font-size: 14px;\n  min-height: 56px;\n}\n.dropdown-menu[data-v-565437c6] {\n  padding: 1.4rem 0 0 0;\n  min-width: 26.5rem;\n}\n.dropdown-menu-items[data-v-565437c6] {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb {\n  background: #c2c2c2;\n  border-radius: 5px;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-thumb:hover {\n  background: #c2c2c2;\n  -webkit-box-shadow: unset;\n}\n.dropdown-menu-items[data-v-565437c6]::-webkit-scrollbar-track {\n  padding-left: 1rem;\n  background: #f2f2f2;\n  -webkit-box-shadow: inset 0 0 6px transparent;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(690)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76d7dcc1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notification_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76d7dcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notification_item_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("5ff169c0", content, true, {});

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown-item[data-v-76d7dcc1]{border-radius:0!important}.dropdown-item.unread[data-v-76d7dcc1],.dropdown-item[data-v-76d7dcc1]:hover{font-family:inherit!important;background-color:hsla(0,0%,75%,.1)}.dropdown-item .icon[data-v-76d7dcc1]{display:block;margin-right:1rem;padding:1rem}.dropdown-item .icon img[data-v-76d7dcc1]{width:36px}", "", {"version":3,"sources":["F:/myugfront/src/components/notification-item.vue"],"names":[],"mappings":"AACA,gCACE,yBAA4B,CAC7B,AACD,6EACE,8BAAgC,AAChC,kCAA2C,CAC5C,AACD,sCACE,cAAe,AACf,kBAAmB,AACnB,YAAc,CACf,AACD,0CACE,UAAY,CACb","file":"notification-item.vue","sourcesContent":["\n.dropdown-item[data-v-76d7dcc1] {\n  border-radius: 0 !important;\n}\n.dropdown-item[data-v-76d7dcc1]:hover, .dropdown-item.unread[data-v-76d7dcc1] {\n  font-family: inherit !important;\n  background-color: rgba(192, 192, 192, 0.1);\n}\n.dropdown-item .icon[data-v-76d7dcc1] {\n  display: block;\n  margin-right: 1rem;\n  padding: 1rem;\n}\n.dropdown-item .icon img[data-v-76d7dcc1] {\n  width: 36px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[{unread: !_vm.item.seen_at}, 'dropdown-item', 'd-flex'],attrs:{"href":_vm.link},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.item.icon}})]),_vm._v(" "),_c('div',[_c('div',{class:{'font-weight-bold': !_vm.item.seen_at},domProps:{"innerHTML":_vm._s(_vm.item.text)}}),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.helpers.getDateDifference(_vm.item.created_at)))])])])}
var staticRenderFns = []


/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown header-notify pl-4"},[_c('a',{staticClass:"nav-link position-relative cursor-pointer",attrs:{"data-toggle":"dropdown"},on:{"click":_vm.loadNotifications}},[(_vm.newNotifications > 0)?_c('span',[_c('span',{staticClass:"pulse"}),_vm._v(" "),_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notification-recieved.png","alt":"notifications"}})]):_c('span',[_c('img',{staticClass:"img-fluid ic position-relative",attrs:{"src":"/static/images/icons/notifications.png","alt":"notifications"}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right dropdown-menu-arrow animated"},[(_vm.loading)?_c('sk-list',{attrs:{"height":0.2,"items-count":4}}):_c('div',{staticClass:"dropdown-menu-items"},[(_vm.notifications.length === 0)?_c('div',{staticClass:"no-notifications"},[_vm._v("\n          "+_vm._s(_vm.$t('notifications.not-found'))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.notifications),function(notification,$index){return _c('notification-item',{key:$index,attrs:{"item":notification},on:{"seen":_vm.setSeen}})})],2),_vm._v(" "),_c('div',{staticClass:" text-center p-2 border-top"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.seeAll()}}},[_vm._v(_vm._s(_vm.$t('notifications.mark-all-as-read')))])])],1)])}
var staticRenderFns = []


/***/ }),

/***/ 694:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sk_navbar_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09aea878_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sk_navbar_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-flex col-lg-2"},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.3}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(697)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31e7222c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_lg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e7222c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_lg_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(698);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("17a670c5", content, true, {});

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".dropdown:hover>.dropdown-menu[data-v-31e7222c]{display:block}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-lg.vue"],"names":[],"mappings":"AACA,gDACE,aAAe,CAChB","file":"nav-header-lg.vue","sourcesContent":["\n.dropdown:hover>.dropdown-menu[data-v-31e7222c] {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-lg-block"},[_c('nav',{staticClass:"navbar navbar-expand-md navbar__lg  fixed-top "},[_c('div',{staticClass:"sm-w-100 d-flex order-1 order-md-2"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row align-items-center"},[_c('li',{staticClass:"nav-item d-flex align-items-center order-2 order-md-1"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item order-1 order-md-2 "},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown order-3 "},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-display":"static","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle"},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e(),_vm._v(" "),_c('skeleton',{attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},[_c('tb-skeleton',{attrs:{"aspect-ratio":0.05}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse order-2 order-md-1 navbarSupportedContent",attrs:{"id":"navbarSupportedContent"}},[_c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_lg-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n            "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n          ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_lg-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")]):_c('a',{staticClass:"dropdown-item",attrs:{"href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n              ")])],1)}),0):_vm._e()],1)}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]


/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__ = __webpack_require__(670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_md_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04416632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_md_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar__md d-none d-sm-block d-md-block d-lg-none"},[_c('nav',{staticClass:"navbar fixed-top"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"}),_vm._v(" "),_c('li',{staticClass:"nav-item d-flex align-items-center"},[_c('language-switcher')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[(_vm.studentPicture)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNavmd"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex "},[_c('ul',{staticClass:"navbar-nav mb-auto "},_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_c('img',{staticClass:"img-fluid pre-icon pr-4",attrs:{"src":navItem.icon,"alt":""}}),_vm._v("\n                "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              ")]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect && navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left mb-5"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":""}})])])}]


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__ = __webpack_require__(671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(703)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0de3b628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_header_sm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0de3b628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_header_sm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("6c98affe", content, true, {});

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, ".navbar .nav-link[data-v-0de3b628]:focus{color:#cb2026}.flag-icon[data-v-0de3b628]{width:38px;height:38px}", "", {"version":3,"sources":["F:/myugfront/src/components/navbar/nav-header-sm.vue"],"names":[],"mappings":"AACA,yCACE,aAAe,CAChB,AACD,4BACE,WAAY,AACZ,WAAa,CACd","file":"nav-header-sm.vue","sourcesContent":["\n.navbar .nav-link[data-v-0de3b628]:focus{\n  color: #cb2026;\n}\n.flag-icon[data-v-0de3b628] {\n  width: 38px;\n  height: 38px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar  d-flex align-items-center navbar__sm  fixed-top  d-block d-sm-none"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto flex-row  align-items-center"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('notifications')],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap d-flex align-items-center",attrs:{"href":"#","id":"navbarDropdown_2","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('div',{staticClass:"circle-border"},[_c('div',{staticClass:"circle "},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.studentPicture,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-md-center dropdown-menu-profile",attrs:{"aria-labelledby":"navbarDropdown_2"}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/profile"}},[_vm._v(_vm._s(_vm.$t('profile.title')))]),_vm._v(" "),_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/logout"}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"navigation-overlay",attrs:{"id":"myNav"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"overlay-content d-flex justify-content-end flex-column h-100 "},[_c('ul',{staticClass:"navbar-nav mb-auto "},[_vm._l((_vm.headerMenuTree),function(navItem,i){return _c('li',{class:navItem.items && navItem.items.length > 0 ? 'nav-item dropdown' : 'nav-item'},[(navItem.items && navItem.items.length > 0)?_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":"#","id":'navbarDropdown_md-' + i,"role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]):_c('router-link',{staticClass:"nav-link text-nowrap",attrs:{"to":navItem.link}},[_vm._v("\n              "+_vm._s(_vm.helpers.getLocalizedField(navItem, 'name', 'name_eng'))+"\n              "),_c('img',{staticClass:"img-fluid pre-icon pl-4",attrs:{"src":navItem.icon,"alt":""}})]),_vm._v(" "),(navItem.items && navItem.items.length > 0)?_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":'navbarDropdown_md-' + i}},_vm._l((navItem.items),function(navSubItem){return _c('span',[(navSubItem.is_oldug_redirect == 0)?_c('router-link',{staticClass:"dropdown-item",attrs:{"to":navSubItem.link}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")]):_c('a',{staticClass:"dropdown-item",attrs:{"target":"_blank","href":'https://old.my.ug.edu.ge/login.php?redirect=' + navSubItem.link + '&token=' + _vm.token}},[_vm._v("\n                    "+_vm._s(_vm.helpers.getLocalizedField(navSubItem, 'name', 'name_eng'))+"\n                  ")])],1)}),0):_vm._e()],1)}),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link text-nowrap"},[_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/geo.svg","alt":""},on:{"click":function($event){return _vm.setLocale('ka')}}}),_vm._v(" "),_c('img',{staticClass:"img-fluid flag-icon pl-4",attrs:{"src":"/static/images/eng.svg","alt":""},on:{"click":function($event){return _vm.setLocale('en')}}})])])],2),_vm._v(" "),_vm._m(3)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(1)"}},[_c('img',{staticClass:"img-fluid ic",staticStyle:{"height":"19px !important"},attrs:{"src":"/static/images/icons/menu.png","alt":"notifications"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item "},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid ic",attrs:{"src":"/static/images/icons/search.png","alt":"search"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('a',{staticClass:"closebtn",attrs:{"href":"javascript:void(0)","onclick":"menuToggle(0)"}},[_c('img',{attrs:{"src":"/static/images/icons/close.png","alt":"close button"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ug-logo mx-auto"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/logo-red.png","alt":"ug-logo"}})])}]


/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-header-lg',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-md',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}}),_vm._v(" "),_c('nav-header-sm',{attrs:{"student-picture":_vm.studentPicture,"header-menu-tree":_vm.headerMenuTree}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-center mt-5 mt-sm-0"},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []


/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(710)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e48c0c90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48c0c90_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(713)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-211f040a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211f040a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("d2b11102", content, true, {});

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"app-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header header top-header"},[_c('div',{staticClass:"container-fluid"},[_c('nav-header')],1)])}
var staticRenderFns = []


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("62111f00", content, true, {});

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(454)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"page-header.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"d-none d-sm-none d-md-block"},[_c('breadcrumb',{attrs:{"items":_vm.breadcrumb}})],1),_vm._v(" "),_c('div',{staticClass:"page-leftheader"},[_c('page-title',{attrs:{"title":_vm.pageTitle}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ 852:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar_sidebar__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_header__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_page_page_header__ = __webpack_require__(709);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'clubs-manage',
  components: {
    sidebar: __WEBPACK_IMPORTED_MODULE_0__components_navbar_sidebar__["a" /* default */],
    appHeader: __WEBPACK_IMPORTED_MODULE_1__components_app_header__["a" /* default */],
    pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_page_page_header__["a" /* default */]
  },
  computed: {
    pageData: function pageData() {
      return {
        title: this.$t('clubs-manage.title'),
        breadcrumb: [{
          icon: '',
          title: this.$t('home.title'),
          link: '/',
          isActive: false
        }, {
          icon: '',
          title: this.$t('clubs-manage.title'),
          link: '/clubs/manage',
          isActive: true
        }]
      };
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/32.14adfb738288e97abdb9.js